import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/atoms/Select";
import type { IFilterOrSortSelectProps } from "@/components/molecules/FilterOrSortSelect/types";

const FilterOrSortSelect = ({
  data,
  value,
  onChange,
}: IFilterOrSortSelectProps) => {
  return (
    <Select
      onValueChange={(filterValue) => onChange(String(filterValue))}
      value={value}
    >
      <SelectTrigger className="w-[180px] max-sm:w-full">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {data.map(({ name, value: valueData }) => (
          <SelectItem key={valueData} value={valueData}>
            {name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default FilterOrSortSelect;
